<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4wLwk9/tc-custom/9781460308981.jpg?1705026083369" alt="This image is the cover for the book Beg for Mercy, The Mercy Hollings Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Beg for Mercy, The Mercy Hollings Novels
      </h1>
      <p class="bookDescription body article font2">
        <p>I've never been certain I'm human <br/><br/>Oh, the X-rays and blood tests are normal, and most people have no reason to suspect I'm more than I appear to be. But if I tell you to do something? You do it -- no ifs, ands or buts. <br/><br/>I call my power the 'press.' <br/><br/>My name  is Mercy Hollings, and if you think that having the power to control people makes my life easy, you're dead wrong. <br/><br/>Because when I get angry, everyone around me is at risk -- Sukey, my friend who has frightening taste in men; my clients, who, ironically, come to me for help; my neighbors, who regard me as a loner; and Sam, a man who wants to know my darkest secret. <br/><br/>I have hurt people in the past, and I don't want that to happen again. But now a powerful stranger is threatening the new life that I've made for myself. <br/><br/>And I'm afraid my anger is taking over.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Toni Andrews
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e49302f6